import { Component } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ITableResponsive } from 'src/app/domain/ITableResponsive';
import { GlobalUtils } from 'src/app/shared/global-utils';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { IEvents } from 'src/app/domain/registration/models/IEvents';
import { FaqService } from '../crud-service';
import { COLUMNS_TO_SHOW_MOBILE, COLUMNS_TO_SHOW_WEB, TABLE_CONFIG_COLUMNS } from '../crud-config';
import { AbstractCrudIndex } from 'src/app/shared/components/crud/abstract-crud-index';
import { Router } from '@angular/router';
import { FaqResponseDialogComponent } from '../faq-response-dialog/faq-response-dialog.component';
import { FormEventComponent } from '../../events-forms/form-event/form-event.component';
import moment from 'moment';

@Component({
  selector: 'app-faq-events-index',
  templateUrl: './crud-index.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [FaqService],
})
export class FaqCrudIndex
  extends AbstractCrudIndex<IEvents>
  implements ITableResponsive {
  override title = 'FAQ';
  override displayedColumns = COLUMNS_TO_SHOW_WEB;
  override configColumns = TABLE_CONFIG_COLUMNS;

  constructor(
    public override dialog: MatDialog,
    public override service: FaqService,
    public override toastService: ToastService,
    public override mediaObserver: MediaObserver,
    public override router: Router
  ) {
    super(dialog, service, toastService, mediaObserver, router);
    mediaObserver.asObservable().subscribe((res) => {
      this.is_mobile = res[0].mqAlias === 'sm' || res[0].mqAlias === 'xs';
      this.displayedColumns = this.is_mobile
        ? COLUMNS_TO_SHOW_MOBILE
        : COLUMNS_TO_SHOW_WEB;
    });
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.loadList();
  }

  override loadList() {
    let params = this.params;
    this.service.getAllResponses(params).subscribe({
      next: ([data, total]) => {
        this.length = total;

        // Verificar se temos dados válidos antes de processá-los
        if (data && Array.isArray(data)) {
          this.dataSource = new MatTableDataSource(
            data.map((item: any) => {
              // Certifique-se de incluir todos os campos necessários, especialmente o campo 'answers'
              return {
                id: item.id,
                code: item.code,
                createdAt:moment(item.createdAt).format('DD/MM/YYYY'),
                formDescription: item.formDescription || 'Sem descrição',
                typeEvent: item.typeEvent,
                typeQuestion: item.typeQuestion,
                name: item.name || 'Não informado',
                email: item.email || 'Não informado',
                telephone: item.telephone || 'Não informado',
                answers: item.answers || [] // Garantir que answers seja sempre um array
              };
            })
          );
          console.log('📌 Dados carregados na tabela:', this.dataSource.data);
        } else {
          console.error('Erro: Dados recebidos não são um array válido:', data);
          this.toastService.showError('Formato de dados inválido recebido do servidor.');
        }
      },
      error: (error) => {
        this.toastService.showError('Erro ao carregar as respostas.');
        console.error('Erro no loadList:', error);
      },
    });
  }

  openResponseDialog(element: any) {
    console.log('📌 Abrindo diálogo de resposta com dados:', element);

    // Verificar se temos dados válidos
    if (!element) {
      console.error('Erro: Tentativa de abrir diálogo sem dados');
      this.toastService.showError('Erro ao abrir o diálogo de resposta');
      return;
    }

    // Garantir que o array answers está definido
    if (!element.answers || !Array.isArray(element.answers)) {
      console.warn('Campo answers ausente ou inválido, inicializando como array vazio');
      element.answers = [];
    }

    // Verificar se os campos obrigatórios estão presentes
    const data = {
      name: element.name || 'Não informado',
      email: element.email || 'Não informado',
      telephone: element.telephone || 'Não informado',
      typeQuestion: element.typeQuestion || 'Não definido',
      answers: element.answers
    };

    console.log('📌 Dados preparados para o diálogo:', data);

    GlobalUtils.openDialog({
      dialog: this.dialog,
      component: FaqResponseDialogComponent,
      data,
      dialogConfig: {
        width: '40%',
      },
      callBack: (result: any) => {
        if (result) {
          console.log('📌 Resultado do diálogo:', result);
        }
      }
    });
  }

  openShow(element: any) {
    if (!element.code) {
      console.error('Erro: Código da resposta está indefinido.');
      return;
    }

    this.service.getFormResponsesByFormId(element.code.toString()).subscribe({
      next: (responses) => {
        GlobalUtils.openDialog({
          dialog: this.dialog,
          dialogConfig: {
            width: '60%',
            height: '80vh',
            maxHeight: '80vh',
            panelClass: 'custom-dialog-container'
          },
          component: FormEventComponent,
          data: {
            type: 'SHOW',
            responses,
            name: element.name,
            email: element.email
          },
          callBack: (data: any) => {
          },
        });
      },
      error: (error) => {
        console.error('Erro ao carregar respostas:', error);
        this.toastService.showError('Erro ao carregar as respostas.');
      },
    });
  }

  sendResponse(response: string, email: string, name: string, question: string) {
    if (!email || email.trim() === '') {
      console.error('Erro: Nenhum e-mail definido para envio.');
      this.toastService.showError('O e-mail do usuário não pode estar vazio.');
      return;
    }

    const emailData = {
      email,
      question,
      response,
      responder: 'Equipe MegaTech',
      responderType: 'Atendimento',
      date: new Date().toISOString(),
    };
    this.service.sendResponseEmail(emailData).subscribe({
      next: () => {
        this.toastService.showSuccess('Resposta enviada com sucesso!');
      },
      error: (error) => {
        console.error('Erro ao enviar e-mail:', error);
        this.toastService.showError('Erro ao enviar a resposta.');
      },
    });
  }

  override delete(element: any) {
    this.service.delete(element.id).subscribe(() => {
      this.loadList();
      this.toastService.showSuccess('Unidade removida com sucesso!');
    });
  }

  override changePage(event: any) {
    this.params.page = event.page;
    this.params.limit = event.limit;
    this.loadList();
  }

  override filter(event: any) {
    this.params.filter = event;
    this.loadList();
  }
}
